import { ReactElement } from 'react';

interface TpHorizontalSplitterProps {
  top: ReactElement;
  bottom: ReactElement | null;
}

// @todo: make the splitter position draggable
function HorizontalSplitter({ top, bottom }: TpHorizontalSplitterProps) {
  if (!bottom) return top;
  const hSplitterWidth = 3;
  const frac = 0.5;
  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div
        style={{
          width: '100%',
          height: `calc(${frac * 100}% - ${hSplitterWidth}px)`,
        }}
      >
        {top}
      </div>
      <div
        style={{
          width: '100%',
          height: `${2 * hSplitterWidth}px`,
          background: 'rgba(128,128,128,0.5)',
        }}
      />
      <div
        style={{
          width: '100%',
          height: `calc(${(1 - frac) * 100}% - ${hSplitterWidth}px)`,
        }}
      >
        {bottom}
      </div>
    </div>
  );
}

export default HorizontalSplitter;
